// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textarea-ohif {\r\n  background-color: #b6b6b6;\r\n  border-color: #b6b6b6;\r\n  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  font-size: 1em;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
